import { useContext } from "react";
import styled from "styled-components";
import { ProductContext } from "../../context/ProductContext";
import { getProductTitle } from "../../utils/productDisplayName";

const Row = styled.figure`
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  width: 100%;
  margin: 0;
  padding: var(--spacing-sm) 0;
  border-bottom: 1px solid var(--bg-300);

  &:last-child {
    border-bottom: none;
  }
`;

const Thumb = styled.div`
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: var(--border-radius-base);
  background-color: var(--bg-200);
  border: 1px solid var(--bg-300);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;

const Details = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Name = styled.span`
  font-size: var(--font-size-small);
  font-weight: 600;
  color: var(--text-100);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

const Quantity = styled.span`
  font-size: var(--font-size-small);
  color: var(--text-200);
`;

const Price = styled.span`
  flex-shrink: 0;
  font-size: var(--font-size-small);
  font-weight: 700;
  color: var(--text-100);
  white-space: nowrap;
`;

const InvoiceProduct = ({ item }) => {
  const { currencyTag } = useContext(ProductContext);

  // Try to find a non-primary image; if none exist, use the primary image as fallback
  const primaryImage =
    item.product.images.find((img) => !img.is_primary) ||
    item.product.images.find((img) => img.is_primary);

  return (
    <Row>
      <Thumb>
        {primaryImage && (
          <Image
            src={primaryImage.thumbnail}
            alt={getProductTitle(item.product.category_name, item.product.name)}
            srcSet={`${primaryImage.thumbnail} 320w, ${primaryImage.large} 480w, ${primaryImage.large} 800w`}
            sizes="56px"
            loading="lazy"
            className="primary-image"
          />
        )}
      </Thumb>
      <Details>
        <Name>
          {getProductTitle(item.product.category_name, item.product.name)}{" "}
          {item.product.nicotine}MG
        </Name>
        <Quantity>{item.quantity} Cans</Quantity>
      </Details>
      <Price>
        {currencyTag}
        {item.product.discount_price.toFixed(2)}
      </Price>
    </Row>
  );
};

export default InvoiceProduct;
